import { useQuery } from '@tanstack/react-query';
import { withBasePath } from '@/utils/withBasePath';

const FEATURE_FLAG_NAME = 'launch_organizer_profile_calendar_view';
const STALE_TIME = 10 * 60 * 1000;

async function fetchCalendarViewTreatment(organizerId: string): Promise<{ treatment: string }> {
  const params = new URLSearchParams({ featureFlagName: FEATURE_FLAG_NAME });
  const res = await fetch(withBasePath(`/api/organizers/${organizerId}/treatment/?${params}`), {
    credentials: 'include',
  });

  if (!res.ok) {
    throw new Error(`Treatment request failed: ${res.status}`);
  }

  return (await res.json()) as { treatment: string };
}

export function useCalendarViewTreatment(organizerId: string | undefined) {
  const id = organizerId?.trim() ?? '';

  const query = useQuery({
    queryKey: ['organizer-treatment', id, FEATURE_FLAG_NAME],
    queryFn: () => fetchCalendarViewTreatment(id),
    enabled: Boolean(id),
    staleTime: STALE_TIME,
  });

  return {
    isCalendarViewEnabled: query.data?.treatment === 'on',
    isLoading: query.isLoading,
  };
}
